// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Domain } from './Domain';
/**
 * An instance of Exception represents a handled or unhandled exception that occurred during execution of the monitored application.
 */
var ExceptionData = /** @class */ (function (_super) {
    __extends(ExceptionData, _super);
    function ExceptionData() {
        var _this = _super.call(this) || this;
        _this.ver = 2;
        _this.exceptions = [];
        _this.properties = {};
        _this.measurements = {};
        return _this;
    }
    return ExceptionData;
}(Domain));
export { ExceptionData };
//# sourceMappingURL=ExceptionData.js.map